import { Switch, Route, Redirect } from "wouter";

import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";

import NotFound from "@pages/NotFound";

function Router() {
  return (
    <Switch>
      <Route path="/" component={require("@pages/Overview").default} />
      <Route path="/overview" component={require("@pages/Overview").default} />
      <Route
        path="/players/statistics"
        component={require("@pages/players/Statistics").default}
      />
      <Route
        path="/players/activity-engagement"
        component={require("@pages/players/ActivityEngagement").default}
      />
      <Route
        path="/players/game-pass"
        component={require("@pages/players/GamePass").default}
      />
      <Route
        path="/players/sign-up"
        component={require("@pages/players/SignUp").default}
      />
      <Route
        path="/players/artificial-intelligence"
        component={require("@pages/players/ArtificialIntelligence").default}
      />
      <Route
        path="/apps/apptweak"
        component={require("@pages/apps/AppTweak").default}
      />
      <Route
        path="/apps/apple-app-store"
        component={require("@pages/apps/AppleAppStore").default}
      />
      <Route
        path="/settings/general"
        component={require("@pages/settings/General").default}
      />
      <Route
        path="/settings/account"
        component={require("@pages/settings/Account").default}
      />
      <Route
        path="/settings/data"
        component={require("@pages/settings/Data").default}
      />
      <Route
        path="/settings/data"
        component={require("@pages/settings/Data").default}
      />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router />
    </QueryClientProvider>
  );
}

export default App;
